import Algorithmia from "Content/images/documentObjectType/Algorithmia.svg";
import Anbchart from "Content/images/documentObjectType/Anbchart.svg";
import Bankruptcy from "Content/images/documentObjectType/Bankruptcy.svg";
import Businessman from "Content/images/documentObjectType/Businessman.svg";
import Car from "Content/images/documentObjectType/Car.svg";
import Censys from "Content/images/documentObjectType/Censys.svg";
import Chart from "Content/images/documentObjectType/Chart.svg";
import Comment from "Content/images/documentObjectType/Comment.svg";
import Communication from "Content/images/documentObjectType/Communication.svg";
import Connection from "Content/images/documentObjectType/Connection.svg";
import Court from "Content/images/documentObjectType/Court.svg";
import Criminal from "Content/images/documentObjectType/Criminal.svg";
import Discord from "Content/images/documentObjectType/Discord.svg";
import Document from "Content/images/documentObjectType/Document.svg";
import Email from "Content/images/documentObjectType/Email.svg";
import Enforcement_Proceedings from "Content/images/documentObjectType/Enforcement Proceedings.svg";
import Exif from "Content/images/documentObjectType/Exif.svg";
import FNS from "Content/images/documentObjectType/FNS.svg";
import General_Group from "Content/images/documentObjectType/General group.svg";
import General from "Content/images/documentObjectType/General.svg";
import Github from "Content/images/documentObjectType/Github.svg";
import Gosuslugi from "Content/images/documentObjectType/Gosuslugi.svg";
import Govrment from "Content/images/documentObjectType/Govrment.svg";
import Hashtag from "Content/images/documentObjectType/Hashtag.svg";
import IP_Address from "Content/images/documentObjectType/IP Address.svg";
import Insurance from "Content/images/documentObjectType/Insurance.svg";
import Legal_Entity from "Content/images/documentObjectType/Legal Entity.svg";
import Map from "Content/images/documentObjectType/Map.svg";
import Notariate from "Content/images/documentObjectType/Notariate.svg";
import Notice from "Content/images/documentObjectType/Notice.svg";
import OCCRP_Company from "Content/images/documentObjectType/OCCRP Company.svg";
import OCCRP_Contract from "Content/images/documentObjectType/OCCRP Contract.svg";
import OCCRP_Court from "Content/images/documentObjectType/OCCRP Court.svg";
import OCCRP_Doc from "Content/images/documentObjectType/OCCRP Doc.svg";
import OCCRP_Email from "Content/images/documentObjectType/OCCRP Email.svg";
import OCCRP_Home from "Content/images/documentObjectType/OCCRP Home.svg";
import OCCRP_Img from "Content/images/documentObjectType/OCCRP Img.svg";
import OCCRP_Legal_Entity from "Content/images/documentObjectType/OCCRP Legal Entity.svg";
import OCCRP_License from "Content/images/documentObjectType/OCCRP License.svg";
import OCCRP_Organization from "Content/images/documentObjectType/OCCRP Organization.svg";
import OCCRP_Pages from "Content/images/documentObjectType/OCCRP Pages.svg";
import OCCRP_Person from "Content/images/documentObjectType/OCCRP Person.svg";
import Person_Shaded_Shirt from "Content/images/documentObjectType/Person (Shaded Shirt).svg";
import Person from "Content/images/documentObjectType/Person.svg";
import Phone from "Content/images/documentObjectType/Phone.svg";
import Pledge from "Content/images/documentObjectType/Pledge.svg";
import Profmale from "Content/images/documentObjectType/Profmale.svg";
import SL_About_Me_Profile from "Content/images/documentObjectType/SL About Me Profile.svg";
import SL_Alias from "Content/images/documentObjectType/SL Alias.svg";
import SL_Armchairgm from "Content/images/documentObjectType/SL Armchairgm.svg";
import SL_Askfm from "Content/images/documentObjectType/SL Askfm.svg";
import SL_Badoo from "Content/images/documentObjectType/SL Badoo.svg";
import SL_Banner from "Content/images/documentObjectType/SL Banner.svg";
import SL_Bitbucket from "Content/images/documentObjectType/SL Bitbucket.svg";
import SL_Blogger_Profile from "Content/images/documentObjectType/SL Blogger Profile.svg";
import SL_Bongacams from "Content/images/documentObjectType/SL Bongacams.svg";
import SL_Chaturbate from "Content/images/documentObjectType/SL Chaturbate.svg";
import SL_Circular_Area from "Content/images/documentObjectType/SL Circular Area.svg";
import SL_Classmates from "Content/images/documentObjectType/SL Classmates.svg";
import SL_Company from "Content/images/documentObjectType/SL Company.svg";
import SL_Cryptocurrency_Address from "Content/images/documentObjectType/SL Cryptocurrency Address.svg";
import SL_Cryptocurrency_Token from "Content/images/documentObjectType/SL Cryptocurrency Token.svg";
import SL_Cryptocurrency_Transaction from "Content/images/documentObjectType/SL Cryptocurrency Transaction.svg";
import SL_DARKNET_FORUM_USER from "Content/images/documentObjectType/SL DARKNET FORUM USER.svg";
import SL_DNSName from "Content/images/documentObjectType/SL DNSName.svg";
import SL_Darknet_Post_2 from "Content/images/documentObjectType/SL Darknet Post 2.svg";
import SL_Darknet_Product from "Content/images/documentObjectType/SL Darknet Product.svg";
import SL_Darknet_Topic from "Content/images/documentObjectType/SL Darknet Topic.svg";
import SL_Darkweb_URL from "Content/images/documentObjectType/SL Darkweb URL.svg";
import SL_Darkweb from "Content/images/documentObjectType/SL Darkweb.svg";
import SL_Disqus from "Content/images/documentObjectType/SL Disqus.svg";
import SL_Domain from "Content/images/documentObjectType/SL Domain.svg";
import SL_Etsy from "Content/images/documentObjectType/SL Etsy.svg";
import SL_Facebook_Album from "Content/images/documentObjectType/SL Facebook Album.svg";
import SL_Facebook_Event from "Content/images/documentObjectType/SL Facebook Event.svg";
import SL_Facebook_Group_Open from "Content/images/documentObjectType/SL Facebook Group Open.svg";
import SL_Facebook_Group from "Content/images/documentObjectType/SL Facebook Group.svg";
import SL_Facebook_Media from "Content/images/documentObjectType/SL Facebook Media.svg";
import SL_Facebook_Page from "Content/images/documentObjectType/SL Facebook Page.svg";
import SL_Facebook_Photo from "Content/images/documentObjectType/SL Facebook Photo.svg";
import SL_Facebook_Playlist from "Content/images/documentObjectType/SL Facebook Playlist.svg";
import SL_Facebook_Post from "Content/images/documentObjectType/SL Facebook Post.svg";
import SL_Facebook_Reply1 from "Content/images/documentObjectType/SL Facebook Reply1.svg";
import SL_Facebook_Report from "Content/images/documentObjectType/SL Facebook Report.svg";
import SL_Facebook_Series from "Content/images/documentObjectType/SL Facebook Series.svg";
import SL_Facebook_User from "Content/images/documentObjectType/SL Facebook User.svg";
import SL_Facebook_Video from "Content/images/documentObjectType/SL Facebook Video.svg";
import SL_Fandom from "Content/images/documentObjectType/SL Fandom.svg";
import SL_Flickr_Profile from "Content/images/documentObjectType/SL Flickr Profile.svg";
import SL_Foursquare_Profile from "Content/images/documentObjectType/SL Foursquare Profile.svg";
import SL_GPS from "Content/images/documentObjectType/SL GPS.svg";
import SL_GUN from "Content/images/documentObjectType/SL GUN.svg";
import SL_GitHub_Profile from "Content/images/documentObjectType/SL GitHub Profile.svg";
import SL_Gitlab from "Content/images/documentObjectType/SL Gitlab.svg";
import SL_Google_Plus from "Content/images/documentObjectType/SL Google Plus.svg";
import SL_Google from "Content/images/documentObjectType/SL Google.svg";
import SL_Gravatar from "Content/images/documentObjectType/SL Gravatar.svg";
import SL_Igmur from "Content/images/documentObjectType/SL Igmur.svg";
import SL_Image from "Content/images/documentObjectType/SL Image.svg";
import SL_Instagram_Photo from "Content/images/documentObjectType/SL Instagram Photo.svg";
import SL_Instagram_Profile from "Content/images/documentObjectType/SL Instagram Profile.svg";
import SL_Instagram_Stories from "Content/images/documentObjectType/SL Instagram Stories.svg";
import SL_Instagram_URL from "Content/images/documentObjectType/SL Instagram URL.svg";
import SL_Instagram_Video from "Content/images/documentObjectType/SL Instagram Video.svg";
import SL_LinkedIn_Groups from "Content/images/documentObjectType/SL LinkedIn Groups.svg";
import SL_Linkedin_Company from "Content/images/documentObjectType/SL Linkedin Company.svg";
import SL_Linkedin_Education from "Content/images/documentObjectType/SL Linkedin Education.svg";
import SL_Linkedin from "Content/images/documentObjectType/SL Linkedin.svg";
import SL_Livejournal from "Content/images/documentObjectType/SL Livejournal.svg";
import SL_Location from "Content/images/documentObjectType/SL Location.svg";
import SL_MX_Scheme from "Content/images/documentObjectType/SL MX Scheme.svg";
import SL_Msdn from "Content/images/documentObjectType/SL Msdn.svg";
import SL_Mutual from "Content/images/documentObjectType/SL Mutual.svg";
import SL_Mymail from "Content/images/documentObjectType/SL Mymail.svg";
import SL_Myspace from "Content/images/documentObjectType/SL Myspace.svg";
import SL_Naver from "Content/images/documentObjectType/SL Naver.svg";
import SL_OK from "Content/images/documentObjectType/SL OK.svg";
import SL_Offshore_Address from "Content/images/documentObjectType/SL Offshore Address.svg";
import SL_Offshore_Company from "Content/images/documentObjectType/SL Offshore Company.svg";
import SL_Offshore_Group from "Content/images/documentObjectType/SL Offshore Group.svg";
import SL_Offshore_Intermediary from "Content/images/documentObjectType/SL Offshore Intermediary.svg";
import SL_Offshore_Officer from "Content/images/documentObjectType/SL Offshore Officer.svg";
import SL_PGP_Key_1 from "Content/images/documentObjectType/SL PGP Key 1.svg";
import SL_Phrase_2 from "Content/images/documentObjectType/SL Phrase 2.svg";
import SL_Pinterest_Profile from "Content/images/documentObjectType/SL Pinterest Profile.svg";
import SL_Pipl from "Content/images/documentObjectType/SL Pipl.svg";
import SL_Pornhub from "Content/images/documentObjectType/SL Pornhub.svg";
import SL_Postal_Code from "Content/images/documentObjectType/SL Postal Code.svg";
import SL_Profile_Exists from "Content/images/documentObjectType/SL Profile Exists.svg";
import SL_Quora from "Content/images/documentObjectType/SL Quora.svg";
import SL_Reddit from "Content/images/documentObjectType/SL Reddit.svg";
import SL_Roblox from "Content/images/documentObjectType/SL Roblox.svg";
import SL_SLDB_Person from "Content/images/documentObjectType/SL SLDB Person.svg";
import SL_Skype from "Content/images/documentObjectType/SL Skype.svg";
import SL_Smart_Contract from "Content/images/documentObjectType/SL Smart Contract.svg";
import SL_Snapchat_Snap from "Content/images/documentObjectType/SL Snapchat Snap.svg";
import SL_Snapchat_User from "Content/images/documentObjectType/SL Snapchat User.svg";
import SL_Soundcloud from "Content/images/documentObjectType/SL Soundcloud.svg";
import SL_Steam from "Content/images/documentObjectType/SL Steam.svg";
import SL_StumbleUpon from "Content/images/documentObjectType/SL StumbleUpon.svg";
import SL_Technet from "Content/images/documentObjectType/SL Technet.svg";
import SL_Telegram_User from "Content/images/documentObjectType/SL Telegram User.svg";
import SL_TikTok_Music from "Content/images/documentObjectType/SL TikTok Music.svg";
import SL_TikTok_Post1 from "Content/images/documentObjectType/SL TikTok Post1.svg";
import SL_TikTok from "Content/images/documentObjectType/SL TikTok.svg";
import SL_Tinder_Profile from "Content/images/documentObjectType/SL Tinder Profile.svg";
import SL_Tradingviev from "Content/images/documentObjectType/SL Tradingviev.svg";
import SL_Trello from "Content/images/documentObjectType/SL Trello.svg";
import SL_Tumblr from "Content/images/documentObjectType/SL Tumblr.svg";
import SL_Twitch from "Content/images/documentObjectType/SL Twitch.svg";
import SL_Twitter_Advanced from "Content/images/documentObjectType/SL Twitter Advanced.svg";
import SL_Twitter_Affilation from "Content/images/documentObjectType/SL Twitter Affilation.svg";
import SL_Twitter_URL from "Content/images/documentObjectType/SL Twitter URL.svg";
import SL_URL from "Content/images/documentObjectType/SL URL.svg";
import SL_VK from "Content/images/documentObjectType/SL VK.svg";
import SL_Vimeo from "Content/images/documentObjectType/SL Vimeo.svg";
import SL_Vulnerability from "Content/images/documentObjectType/SL Vulnerability.svg";
import SL_Whatsapp from "Content/images/documentObjectType/SL Whatsapp.svg";
import SL_Wikileaks from "Content/images/documentObjectType/SL Wikileaks.svg";
import SL_Wikipedia from "Content/images/documentObjectType/SL Wikipedia.svg";
import SL_Xhamster from "Content/images/documentObjectType/SL Xhamster.svg";
import SL_Xing_Profile from "Content/images/documentObjectType/SL Xing Profile.svg";
import SL_Xvideos from "Content/images/documentObjectType/SL Xvideos.svg";
import SL_Yandex_Music from "Content/images/documentObjectType/SL Yandex Music.svg";
import SL_Yandex_Zen from "Content/images/documentObjectType/SL Yandex Zen.svg";
import SL_Youtube_Profile from "Content/images/documentObjectType/SL Youtube Profile.svg";
import SL_Zhihu from "Content/images/documentObjectType/SL Zhihu.svg";
import SL_linkedin_post1 from "Content/images/documentObjectType/SL linkedin post1.svg";
import Sanctions from "Content/images/documentObjectType/Sanctions.svg";
import Search from "Content/images/documentObjectType/Search.svg";
import StoredQuery from "Content/images/documentObjectType/StoredQuery.svg";
import Traffic_Police from "Content/images/documentObjectType/Traffic Police.svg";
import Wanted from "Content/images/documentObjectType/Wanted.svg";
import Web_Page from "Content/images/documentObjectType/Web Page.svg";
import Whois from "Content/images/documentObjectType/Whois.svg";
const documentObjectIconIdIconMap = {
    Algorithmia,
    Anbchart,
    Bankruptcy,
    Businessman,
    Car,
    Censys,
    Comment,
    Communication,
    Connection,
    Court,
    Criminal,
    Chart,
    Discord,
    Document,
    Email,
    "Enforcement Proceedings": Enforcement_Proceedings,
    Exif,
    FNS,
    "General group": General_Group,
    General,
    Github,
    Govrment,
    Gosuslugi,
    Hashtag,
    "IP Address": IP_Address,
    Insurance,
    "Legal Entity": Legal_Entity,
    Map,
    Notariate,
    Notice,
    "OCCRP Company": OCCRP_Company,
    "OCCRP Contract": OCCRP_Contract,
    "OCCRP Court": OCCRP_Court,
    "OCCRP Doc": OCCRP_Doc,
    "OCCRP Email": OCCRP_Email,
    "OCCRP Home": OCCRP_Home,
    "OCCRP Img": OCCRP_Img,
    "OCCRP Legal Entity": OCCRP_Legal_Entity,
    "OCCRP License": OCCRP_License,
    "OCCRP Organization": OCCRP_Organization,
    "OCCRP Pages": OCCRP_Pages,
    "OCCRP Person": OCCRP_Person,
    "Person (Shaded Shirt)": Person_Shaded_Shirt,
    Person,
    Phone,
    Pledge,
    Profmale,
    Sanctions,
    Search,
    Wanted,
    Whois,
    "SL About Me Profile": SL_About_Me_Profile,
    "SL Alias": SL_Alias,
    "SL Armchairgm": SL_Armchairgm,
    "SL Askfm": SL_Askfm,
    "SL Badoo": SL_Badoo,
    "SL Banner": SL_Banner,
    "SL Bitbucket": SL_Bitbucket,
    "SL Blogger Profile": SL_Blogger_Profile,
    "SL Bongacams": SL_Bongacams,
    "SL Chaturbate": SL_Chaturbate,
    "SL Circular Area": SL_Circular_Area,
    "SL Classmates": SL_Classmates,
    "SL Company": SL_Company,
    "SL Cryptocurrency Address": SL_Cryptocurrency_Address,
    "SL Cryptocurrency Token": SL_Cryptocurrency_Token,
    "SL Smart Contract": SL_Smart_Contract,
    "SL Cryptocurrency Transaction": SL_Cryptocurrency_Transaction,
    "SL DARKNET FORUM USER": SL_DARKNET_FORUM_USER,
    "SL Darknet Post 2": SL_Darknet_Post_2,
    "SL Darknet Product": SL_Darknet_Product,
    "SL Darknet Topic": SL_Darknet_Topic,
    "SL Darkweb": SL_Darkweb,
    "SL Darkweb URL": SL_Darkweb_URL,
    "SL Disqus": SL_Disqus,
    "SL DNSName": SL_DNSName,
    "SL Domain": SL_Domain,
    "SL Etsy": SL_Etsy,
    "SL Facebook Album": SL_Facebook_Album,
    "SL Facebook Event": SL_Facebook_Event,
    "SL Facebook Group Open": SL_Facebook_Group_Open,
    "SL Facebook Group": SL_Facebook_Group,
    "SL Facebook Media": SL_Facebook_Media,
    "SL Facebook Page": SL_Facebook_Page,
    "SL Facebook Photo": SL_Facebook_Photo,
    "SL Facebook Playlist": SL_Facebook_Playlist,
    "SL Facebook Post": SL_Facebook_Post,
    "SL Facebook Reply1": SL_Facebook_Reply1,
    "SL Facebook Report": SL_Facebook_Report,
    "SL Facebook Series": SL_Facebook_Series,
    "SL Facebook User": SL_Facebook_User,
    "SL Facebook Video": SL_Facebook_Video,
    "SL Fandom": SL_Fandom,
    "SL Flickr Profile": SL_Flickr_Profile,
    "SL Foursquare Profile": SL_Foursquare_Profile,
    "SL GitHub Profile": SL_GitHub_Profile,
    "SL Gitlab": SL_Gitlab,
    "SL Google Plus": SL_Google_Plus,
    "SL Google": SL_Google,
    "SL GPS": SL_GPS,
    "SL Gravatar": SL_Gravatar,
    "SL GUN": SL_GUN,
    "SL Igmur": SL_Igmur,
    "SL Image": SL_Image,
    "SL Instagram Photo": SL_Instagram_Photo,
    "SL Instagram Profile": SL_Instagram_Profile,
    "SL Instagram Stories": SL_Instagram_Stories,
    "SL Instagram URL": SL_Instagram_URL,
    "SL Instagram Video": SL_Instagram_Video,
    "SL Linkedin Company": SL_Linkedin_Company,
    "SL Linkedin Education": SL_Linkedin_Education,
    "SL LinkedIn Groups": SL_LinkedIn_Groups,
    "SL linkedin post1": SL_linkedin_post1,
    "SL Linkedin": SL_Linkedin,
    "SL Livejournal": SL_Livejournal,
    "SL Location": SL_Location,
    "SL Msdn": SL_Msdn,
    "SL Mutual": SL_Mutual,
    "SL MX Scheme": SL_MX_Scheme,
    "SL Mymail": SL_Mymail,
    "SL Myspace": SL_Myspace,
    "SL Naver": SL_Naver,
    "SL Offshore Address": SL_Offshore_Address,
    "SL Offshore Group": SL_Offshore_Group,
    "SL Offshore Company": SL_Offshore_Company,
    "SL Offshore Intermediary": SL_Offshore_Intermediary,
    "SL Offshore Officer": SL_Offshore_Officer,
    "SL OK": SL_OK,
    "SL PGP Key 1": SL_PGP_Key_1,
    "SL Phrase 2": SL_Phrase_2,
    "SL Pinterest Profile": SL_Pinterest_Profile,
    "SL Pipl": SL_Pipl,
    "SL Pornhub": SL_Pornhub,
    "SL Postal Code": SL_Postal_Code,
    "SL Profile Exists": SL_Profile_Exists,
    "SL Quora": SL_Quora,
    "SL Reddit": SL_Reddit,
    "SL Roblox": SL_Roblox,
    "SL Skype": SL_Skype,
    "SL SLDB Person": SL_SLDB_Person,
    "SL Snapchat Snap": SL_Snapchat_Snap,
    "SL Snapchat User": SL_Snapchat_User,
    "SL Soundcloud": SL_Soundcloud,
    "SL Steam": SL_Steam,
    "SL StumbleUpon": SL_StumbleUpon,
    "SL Technet": SL_Technet,
    "SL Telegram User": SL_Telegram_User,
    "SL TikTok Post1": SL_TikTok_Post1,
    "SL TikTok Music": SL_TikTok_Music,
    "SL TikTok": SL_TikTok,
    "SL Tinder Profile": SL_Tinder_Profile,
    "SL Tradingviev": SL_Tradingviev,
    "SL Trello": SL_Trello,
    "SL Tumblr": SL_Tumblr,
    "SL Twitch": SL_Twitch,
    "SL Twitter Advanced": SL_Twitter_Advanced,
    "SL Twitter Affilation": SL_Twitter_Affilation,
    "SL Twitter URL": SL_Twitter_URL,
    "SL URL": SL_URL,
    "SL Vimeo": SL_Vimeo,
    "SL VK": SL_VK,
    "SL Vulnerability": SL_Vulnerability,
    "SL Whatsapp": SL_Whatsapp,
    "SL Wikileaks": SL_Wikileaks,
    "SL Wikipedia": SL_Wikipedia,
    "SL Xhamster": SL_Xhamster,
    "SL Xing Profile": SL_Xing_Profile,
    "SL Xvideos": SL_Xvideos,
    "SL Yandex Music": SL_Yandex_Music,
    "SL Yandex Zen": SL_Yandex_Zen,
    "SL Youtube Profile": SL_Youtube_Profile,
    "SL Zhihu": SL_Zhihu,
    StoredQuery,
    "Traffic Police": Traffic_Police,
    "Web Page": Web_Page
};
export default documentObjectIconIdIconMap;
